<template>
  <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
    <div class="row">
      <div class="col col-md-4 col-lg-4 hidden-sm-down opacity-20">
        <img src="/img/logo-scm.svg" class="w-100" aria-roledescription="logo" :alt="appTitle" />
      </div>

      <div class="col-sm-12 col-md-8 col-lg-8 col-xl-7 ml-auto">
        <div class="card p-4 rounded-0 bg-faded">
          <h1 class="h2 text-left fw-600 mb-4 d-xs-block">{{ $t('titles.sign-up') }}</h1>

          <form>
            <div class="form-group">
              <w-input
                :model="$schema.profile.email"
                :title="$t($schema.profile.email.$schema.title)"
              />
            </div>

            <div class="row">
              <div class="form-group col-md-6">
                <w-input
                  :model="$schema.profile.firstName"
                  :title="$t($schema.profile.firstName.$schema.title)"
                />
              </div>

              <div class="form-group col-md-6">
                <w-input
                  :model="$schema.profile.lastName"
                  :title="$t($schema.profile.lastName.$schema.title)"
                />
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-6">
                <w-input
                  :model="$schema.profile.phoneNumber"
                  :title="$t($schema.profile.phoneNumber.$schema.title)"
                />
              </div>

              <div class="form-group col-md-6">
                <form-datepicker
                  :model="$schema.profile.birthDate"
                  :title="$t($schema.profile.birthDate.$schema.title)"
                />
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-12">
                <terms-list
                  :termsList="termsList"
                  :termsIds="$schema.termsIds"
                  @view="showContentModal($event.name, $event.content)"
                />
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col-lg-12 pl-lg-1 my-2 text-right">
                <button
                  class="btn btn-smart btn-lg rounded-pill"
                  @click.prevent="submit()"
                >{{ $t('buttons.sign-up') }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <preview-modal
      :show="previewModal"
      :text="previewModalText"
      :title="previewModalTitle"
      @close="closeContentModal"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import PreviewModal from '@/components/modals/PreviewModal';
import { Storage } from '@/enums/storage.enum';
import schema from '@/schemas/register.schema';
import { formMixin } from '@/mixins/form';
import { notificationsMixin } from '@/mixins/notifications';
import previewModalMixin from '@/mixins/previewModal.mixin';
import { authResource } from '@/resources/auth.resource';
import TermsList from '@/components/TermsList';

// @vuese
// Rejestracja
// @group Start
export default {
  mixins: [formMixin, notificationsMixin, previewModalMixin],
  external: {},
  data() {
    return {
      list: [],
      model: {
        termsIds: [],
        profile: {
          lang: '',
          email: '',
          firstName: '',
          lastName: '',
          phoneNumber: '',
          birthDate: ''
        }
      },
      tokens: {},
      success: false
    };
  },
  computed: mapState({
    appTitle: state => state.system.appTitle,
    termsList: state => state.terms.list
  }),
  components: {
    TermsList,
    PreviewModal
  },
  schema,
  methods: {
    // @vuese
    // Rejestruje użytkownika
    async submit() {
      if (this.$route.params.type && this.$route.params.token) {
        this.tokens[this.$route.params.type + 'Token'] = this.$route.params.token;
      }

      this.$schema.$setData({
        profile: { lang: localStorage.getItem(Storage.LANG) || process.env.VUE_APP_I18N_LOCALE }
      });

      if (!this.$schema.$validateAll().length) {
        authResource
          .register(this.model.profile, this.tokens, this.model.termsIds)
          .then(() =>
            this.$store.dispatch('showConfirm', {
              title: 'Konto zostało zarejestrowane',
              description: 'Kliknij w link wysłany na twój adres e-mail, aby potwierdzić konto.',
              showCloseButton: false,
              submitButton: 'Ok',
              onSuccess: () => this.$router.push({ name: 'login' })
            })
          )
          .catch(err => this.notifyError(err.message || 'messages.errorLong'));
      }
    }
  },
  beforeCreate() {
    this.$options.external = {
      requiredLength: this.$store.state.terms.list.length
    };
  }
};
</script>
